/** @import modules */

import { useTranslation }   from "react-i18next";

import { Helmet }           from "react-helmet-async";

import {
    hreflangLinks,
    localizedAbsoluteUrl,
    localizedValue,
    normalizeLanguage
}                           from "../../Components/SEO/localizedMeta";

/** @import contexts */

import { MontageContext }   from "../../Contexts/MontageContext";

/** @import hookes */

import { MontageHook }      from "../../Hooks/Montage";

/** @import components */

import Breadcrumbs          from "../../Components/Layout/Header/Breadcrumbs";

import MontageLayout        from "../../Components/Montage/Layout";

import Type                 from "../../Components/Montage/Type";

import Forms                from "../../Components/Montage/Forms";

/**
 * 
 * @returns montage page
 * 
 */

const Montage = () => { const { t, i18n } = useTranslation (),

    currentLanguage = normalizeLanguage(i18n?.resolvedLanguage || i18n?.language),

    canonicalHref = localizedAbsoluteUrl("/content/montage", currentLanguage),

    alternateLinks = hreflangLinks("/content/montage"),

    pageDescription = localizedValue({
        lv: "E-pieraksts riepu servisam Tireshop.lv: izvēlies pakalpojumu, datumu un laiku riepu maiņai, montāžai un balansēšanai ērti tiešsaistē.",
        en: "Online booking for tire service at Tireshop.lv: choose service, date, and time for tire replacement, fitting, and balancing.",
        ru: "Онлайн-запись в шиномонтаж Tireshop.lv: выберите услугу, дату и время для замены шин, монтажа и балансировки."
    }, currentLanguage);

    /** @return component */

    return ( <div className="container max-content-width">

        <Helmet>

            <title>{ `Tireshop.lv | ${ t ( "montage" ) }` }</title>

            <meta
                name="description"
                content={ pageDescription }
            />

            <link rel="canonical" href={ canonicalHref } />

            { alternateLinks.map((item) => (
                <link
                    key={ item.hreflang }
                    rel="alternate"
                    hrefLang={ item.hreflang }
                    href={ item.href }
                />
            )) }

        </Helmet>

        <Breadcrumbs collection={ [

            { name: t ( "montage" ), URI: "/content/montage" }

        ] } />

        <MontageLayout>

            <MontageContext.Provider value={ MontageHook () }>

                <Type />

                <Forms />

            </MontageContext.Provider>

        </MontageLayout>
        
    </div> );

}

/** @export Montage */
 
export default Montage;
